import { createUseStyles } from 'react-jss'

const useTimesListStyles = createUseStyles(() => ({
  timesList: {
    marginBottom: '1rem'
  }
}))

export { useTimesListStyles }
